module.exports = __webpack_public_path__ + "static/img/brand-13.d3b41e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-13.png
// module id = 1CAU
// module chunks = 0